// Lib
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// Utils
import { propIn } from '../../../../common/utils/immutableHelper';

// Selector
import { getElementLocalData } from '../../local/elementLocalDataSelector';

const getLocalEditorState = propIn(['editorState']);

const mapStateToProps = createSelector(getElementLocalData, (elementLocalData) => ({
    localEditorState: getLocalEditorState(elementLocalData),
}));

export default connect(mapStateToProps);
